import ApiClient from './ApiClient';

class CrmProductsAPI extends ApiClient {
  constructor() {
    super('crm_products', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { crm_product: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { crm_product: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CrmProductsAPI();
